export default {
  emails: "api/sent-mails/",
  singleList: (id) => `api/sent-mails/?campaign_id=${id}`,
  status: (id) => `api/sent-mails/?campaign_id=${id}&is_delivered=false&all`,
  deliveredStatus: (id) =>
    `api/sent-mails/?campaign_id=${id}&is_delivered=true&all`,
  // emailsPag: (id) => `api/paginated-sent-mails/?limit=10&offset=${id}`,

  filterNewEmails: (id) => `api/all-filtered-sent-mails/?mail_campaign_id=${id}`,
  
  filterEmails: (data) => {
    // Start with the required parameter
    let url = `api/filtered-sent-mails/?mail_campaign_id=${data.mail_campaign_id}`;
    
    // Only add parameters that have true values or non-null values
    if (data.is_delivered === true) url += `&is_delivered=${data.is_delivered}`;
    if (data.is_opened === true) url += `&is_opened=${data.is_opened}`;
    if (data.is_clicked === true) url += `&is_clicked=${data.is_clicked}`;
    if (data.is_sent === true) url += `&is_sent=${data.is_sent}`;
    if (data.page) url += `&page=${data.page}`;
    if (data.to_email) url += `&to_email=${data.to_email}`;
    
    return url;
  },

    
emailsPag: (data) => {
  // Start with the required parameter
  let url = "api/paginated-sent-mails/";

  // Only add the campaign_id parameter if it's neither null nor undefined
  if (data.mail_campaign_id !== null && data.mail_campaign_id !== undefined) {
    url += `?campaign_id=${data.mail_campaign_id}`;
  }

  // Only add parameters that have true values or non-null/undefined values
  const filters = [
    { key: "is_delivered", value: data.is_delivered },
    { key: "is_opened", value: data.is_opened },
    { key: "is_clicked", value: data.is_clicked },
    { key: "is_sent", value: data.is_sent },
    { key: "page", value: data.page },
    { key: "to_email", value: data.to_email },
  ];

  // Loop through filters and append to the URL only if the value is valid
  filters.forEach(filter => {
    if (filter.value !== undefined && filter.value !== null) {
      // Add the ampersand (`&`) if the URL already has query parameters
      url += (url.includes('?') ? '&' : '?') + `${filter.key}=${filter.value}`;
    }
  });

  return url;
}


 
};
